export const defaultPaymentMethods = {
  cash: true,
  card: true,
  bankTransfer: true,
  jazzCash: true,
  easyPaisa: false,
};

export const defaultPaymentConfig = {
  bankName: '',
  accountName: '',
  accountNumber: '',
  iban: '',
  jazzCashNumber: '',
  easyPaisaNumber: '',
  paymentInstructions: '',
};

export const apiPaymentMethods = [];

export const defaultApiConnections = {};

export const paymentMethodMeta = [
  { key: 'cash', label: 'Cash', description: 'Accept in-person cash payments at reception', icon: 'CA' },
  { key: 'card', label: 'Card', description: 'Accept debit and credit card payments', icon: 'CD' },
  { key: 'bankTransfer', label: 'Bank Transfer', description: 'Accept direct bank transfers', icon: 'BK' },
  { key: 'jazzCash', label: 'JazzCash', description: 'Accept JazzCash mobile wallet payments', icon: 'JC' },
  { key: 'easyPaisa', label: 'EasyPaisa', description: 'Accept EasyPaisa mobile account payments', icon: 'EP' },
];

export const methodConfigFields = {
  cash: [
    { name: 'paymentInstructions', label: 'Cash Payment Instructions', type: 'textarea', full: true, rows: 3 },
  ],
  card: [
    { name: 'paymentInstructions', label: 'Card Payment Instructions', type: 'textarea', full: true, rows: 3 },
  ],
  bankTransfer: [
    { name: 'bankName', label: 'Bank Name' },
    { name: 'accountName', label: 'Account Name' },
    { name: 'accountNumber', label: 'Account Number' },
    { name: 'iban', label: 'IBAN' },
  ],
  jazzCash: [
    { name: 'jazzCashNumber', label: 'JazzCash Number' },
  ],
  easyPaisa: [
    { name: 'easyPaisaNumber', label: 'EasyPaisa Number' },
  ],
};
